import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';
import { PencilIconComponent, IconTypes } from '../pencil-icon/pencil-icon.component';
import { TruncateStringPipe } from '../../pipes/truncate-string.pipe';

export interface PencilDropdownButtonOption {
  id: string | number;
  value: string;
}

@Component({
  selector: 'app-pencil-drop-down-button',
  templateUrl: './pencil-drop-down-button.component.html',
  styleUrls: ['./pencil-drop-down-button.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    PencilButtonComponent,
    PencilIconComponent,
    FormsModule,
    TruncateStringPipe,
    TranslateModule,
  ],
})
export class PencilDropDownButtonComponent implements AfterViewInit {
  @Input() options: PencilDropdownButtonOption[] = [];
  @Input() selectedOption?: PencilDropdownButtonOption;
  @Input() placeholder: string = this.translateService.instant('Select an option');
  @Input() disabled: boolean = false;
  @Input() maxOptionLength: number = 50; // use in case of options with length more than the dropdown button width

  @Output() selectionChange = new EventEmitter<PencilDropdownButtonOption>();

  @ViewChild('dropdownButton', { read: ElementRef }) dropdownButton!: ElementRef;

  isMenuOpen: boolean = false;
  IconTypes = IconTypes;

  constructor(private translateService: TranslateService) {}

  ngAfterViewInit(): void {
    const dropdownButtonWidth = this.dropdownButton.nativeElement.offsetWidth;
    if (dropdownButtonWidth) {
      document.documentElement.style.setProperty(
        '--dropdown-menu-width',
        `${dropdownButtonWidth}px`,
      );
    }
  }

  onOptionSelected(option: PencilDropdownButtonOption): void {
    this.selectedOption = option;
    this.selectionChange.emit(option);
  }

  onMenuClosed(): void {
    this.isMenuOpen = false;
  }

  onMenuOpened(): void {
    this.isMenuOpen = true;
  }
}
